import React from 'react';
import Image from 'next/image';
import { TwitterCardData } from '../index';

interface TwitterCardProps {
  data: TwitterCardData;
}

const TwitterCard: React.FC<TwitterCardProps> = ({ data }) => {
  const handleCardClick = () => {
    window.open(data.link, '_blank');
  };

  // 将文本中的话题标签（#hashtag）转换为带样式的元素
  const renderContent = (text: string) => {
    // 匹配话题标签的正则表达式
    const hashtagRegex = /(#[a-zA-Z0-9_\u00C0-\u017F]+)/g;
    const parts = text.split(hashtagRegex);

    return parts.map((part, index) => {
      // 如果是话题标签，应用特殊样式
      if (part.match(hashtagRegex)) {
        return (
          <span key={index} className="text-[var(--app-primary-color,#725CFF)] font-medium">
            {part}
          </span>
        );
      }
      // 普通文本
      return <span key={index}>{part}</span>;
    });
  };

  return (
    <div
      className="mt-[4px] min-w-[350px] max-w-[380px] max-md:min-w-[300px] max-md:max-w-[320px] bg-white rounded-2xl p-5 max-md:p-4 border border-gray-200 cursor-pointer h-fit transition-all duration-300 hover:-translate-y-1 hover:border-gray-300 flex flex-col"
      data-twitter-card="true"
      onClick={handleCardClick}
    >
      <div className="flex items-center gap-3 mb-4">
        <Image src={data.userAvatar} alt={data.userName} width={48} height={48} className="rounded-full object-cover" />
        <div>
          <div className="text-base font-bold text-[#0c0c0c] leading-[1.3]">{data.userName}</div>
          <div className="text-sm text-[#666666] leading-[1.3]">{data.userHandle}</div>
        </div>
      </div>
      <div className="text-[15px] text-[#0f1419] leading-[1.5] mb-4 break-words whitespace-pre-wrap">
        {renderContent(data.content)}
      </div>

      {data.image && (
        <div className="relative w-full rounded-xl overflow-hidden">
          <Image src={data.image} alt="Tweet image" width={380} height={300} className="w-full h-auto object-cover" />
        </div>
      )}
    </div>
  );
};

export default TwitterCard;
